import Controller from "./captainVerification.controller";
import template from "./captainVerification.html";

const captainVerification = {
  template,
  controller: Controller,
};

export default captainVerification;



// WEBPACK FOOTER //
// ./src/pages/captainVerification/captainVerification.component.js